const artifactContributionInstanceTypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-contribution-instance-type",
    "code": "reviewed",
    "display": "Reviewed",
    "definition": "Reviewed"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-contribution-instance-type",
    "code": "approved",
    "display": "Approved",
    "definition": "Approved"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-contribution-instance-type",
    "code": "edited",
    "display": "Edited",
    "definition": "Edited"
  }
]

const artifactRelationshipTypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "amended-with",
    "display": "Amended With",
    "definition": "This artifact is amended with or changed by the target artifact. There is information      in this artifact that should be functionally replaced with information in the target      artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "amends",
    "display": "Amends",
    "definition": "This artifact amends or changes the target artifact. This artifact adds additional      information that is functionally expected to replace information in the target      artifact. This artifact replaces a part but not all of the target artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "appended-with",
    "display": "Appended With",
    "definition": "This artifact has additional information in the target artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "appends",
    "display": "Appends",
    "definition": "This artifact adds additional information to the target artifact. The additional      information does not replace or change information in the target artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "cited-by",
    "display": "Cited By",
    "definition": "This artifact is cited by the target artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "cites",
    "display": "Cites",
    "definition": "This artifact cites the target artifact. This may be a bibliographic citation for      papers, references, or other relevant material for the knowledge resource. This      is intended to allow for citation of related material, but that was not necessarily      specifically prepared in connection with this knowledge resource."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "cite-as",
    "display": "Cite As",
    "definition": "The related artifact is the citation for this artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "comments-on",
    "display": "Is Comment On",
    "definition": "This artifact contains comments about the target artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "comment-in",
    "display": "Has Comment In",
    "definition": "This artifact has comments about it in the target artifact.  The type of comments      may be expressed in the targetClassifier element such as reply, review, editorial,      feedback, solicited, unsolicited, structured, unstructured."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "composed-of",
    "display": "Composed Of",
    "definition": "This artifact incorposrates the target artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "contained-in",
    "display": "Contained In",
    "definition": "This artifact is contained in the target artifact. The target artifact is a data      structure whose instances are collections of other objects."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "contains",
    "display": "Contains",
    "definition": "This artifact is a container in which the target artifact is contained. A container      is a data structure whose instances are collections of other objects. (A database      contains the dataset.)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "correction-in",
    "display": "Correction In",
    "definition": "This artifact has corrections to it in the target artifact. The target artifact      identifies errors and replacement content for this artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "corrects",
    "display": "Corrects",
    "definition": "This artifact identifies errors and replacement content for the target artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "created-with",
    "display": "Created With",
    "definition": "This artifact was created with the target artifact. The target artifact is a tool      or support material used in the creation of the artifact, and not content that      the artifact was derived from."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "depends-on",
    "display": "Depends On",
    "definition": "This artifact depends on the target artifact. There is a requirement to use the      target artifact in the creation or interpretation of this artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "derived-from",
    "display": "Derived From",
    "definition": "This artifact is derived from the target artifact. This is intended to capture      the relationship in which a particular knowledge resource is based on the content      of another artifact, but is modified to capture either a different set of overall      requirements, or a more specific set of requirements such as those involved in      a particular institution or clinical setting. The artifact may be derived from      one or more target artifacts."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "justification",
    "display": "Justification",
    "definition": "The target artifact is a summary of the justification for the knowledge resource      including supporting evidence, relevant guidelines, or other clinically important      information. This information is intended to provide a way to make the justification      for the knowledge resource available to the consumer of interventions or results      produced by the knowledge resource."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "part-of",
    "display": "Part Of",
    "definition": "This artifact is a part of the target artifact. The target artifact is composed      of this artifact (and possibly other artifacts)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "predecessor",
    "display": "Predecessor",
    "definition": "The previous version of the knowledge artifact, used to establish an ordering of      versions of an artifact, independent of the status of each version."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "replaced-with",
    "display": "Replaced With",
    "definition": "This artifact is replaced with or superseded by the target artifact. This artifact      may be considered deprecated."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "replaces",
    "display": "Replaces",
    "definition": "This artifact replaces or supersedes the target artifact. The target artifact may      be considered deprecated."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "reprint",
    "display": "Reprint",
    "definition": "A copy of the artifact in a publication with a different artifact identifier."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "reprint-of",
    "display": "Reprint Of",
    "definition": "The original version of record for which the current artifact is a copy."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "retracted-by",
    "display": "Retracted By",
    "definition": "This artifact is retracted by the target artifact. The content that was published      in this artifact should be considered removed from publication and should no longer      be considered part of the public record."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "retracts",
    "display": "Retracts",
    "definition": "This artifact retracts the target artifact. The content that was published in the      target artifact should be considered removed from publication and should no longer      be considered part of the public record."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "signs",
    "display": "Signs",
    "definition": "This artifact is a signature of the target artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "similar-to",
    "display": "Similar To",
    "definition": "This artifact has characteristics in common with the target artifact. This relationship      may be used in systems to “deduplicate” knowledge artifacts from different sources,      or in systems to show “similar items”."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "specification-of",
    "display": "Specification Of",
    "definition": "The target artifact is a precise description of a concept in this artifact. This      may be used when the RelatedArtifact datatype is used in elements contained in      this artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "successor",
    "display": "Successor",
    "definition": "The subsequent version of the knowledge artfact, used to establish an ordering      of versions of an artifact, independent of the status of each version."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "summarizes",
    "display": "Summarizes",
    "definition": "This document summarizes the content from the (source) target document."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "supported-with",
    "display": "Supported With",
    "definition": "The target artifact contains additional information related to the knowledge artifact. Examples include documentation, instructions, or an associated dataset."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "supports",
    "display": "Supports",
    "definition": "This artifact provides additional support for the target artifact. This could include additional instructions on usage as well as additional information on clinical context or appropriateness."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "transformed-into",
    "display": "Transformed Into",
    "definition": "This artifact was transformed into the target artifact (e.g., by format or language      conversion)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "transformed-with",
    "display": "Transformed With",
    "definition": "This artifact was generated by transforming a related artifact (e.g., format or      language conversion), noted separately with the “transforms” relationship type.      This transformation used the target artifact to inform the transformation. The      target artifact may be a conversion script or translation guide."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
    "code": "transforms",
    "display": "Transforms",
    "definition": "This artifact was generated by transforming the target artifact (e.g., format or      language conversion). This is intended to capture the relationship in which a particular      knowledge resource is based on the content of another artifact, but changes are      only apparent in form and there is only one target artifact with the “transforms”      relationship type."
  }
]

const artifactRelationshipTypeValueSetLookup = {};
for (let item of artifactRelationshipTypeValueSet) {
  artifactRelationshipTypeValueSetLookup[item.code] = {
    "coding": [{
      "system": item.system,
      "code": item.code,
      "display": item.display
    }]
  };
}

const artifactUrlClassifierValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "abstract",
    "display": "Abstract",
    "definition": "The URL will reach a brief summary for the article."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "full-text",
    "display": "Full-Text",
    "definition": "The URL will reach the full-text of the article."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "supplement",
    "display": "Supplement",
    "definition": "The URL will reach a supplement, appendix, or additional supporting information for the article."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "webpage",
    "display": "Webpage",
    "definition": "The URL will reach a webpage related to the article, where the content is not easily classified as abstract, full-text or supplement."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "file-directory",
    "display": "File directory",
    "definition": "The URL will reach a file directory."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "code-repository",
    "display": "Code repository",
    "definition": "File archive and web hosting facility for source code of software, documentation, web pages, and other works."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "restricted",
    "display": "Restricted",
    "definition": "The URL content has restricted access (e.g. subcription required)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "compressed-file",
    "display": "Compressed file",
    "definition": "Compressed archive file (e.g. a zip file) that contains multiple files"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "doi-based",
    "display": "DOI Based",
    "definition": "The URL is derived from the Digital Object Identifier (DOI)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "pdf",
    "display": "PDF",
    "definition": "The URL will reach content in PDF form."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "json",
    "display": "JSON",
    "definition": "The URL will reach content in JSON format."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "xml",
    "display": "XML",
    "definition": "The URL will reach content in XML format."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "version-specific",
    "display": "Version Specific",
    "definition": "The URL will reach content that is a specific version of the article."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "computable-resource",
    "display": "Computable resource",
    "definition": "The URL will reach content that is machine-interpretable."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/artifact-url-classifier",
    "code": "not-specified",
    "display": "Not Specified",
    "definition": "Used when URL classifier is not specified but expected in a system."
  }
]

const citationArtifactClassifierValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "audio",
    "display": "Audio file",
    "definition": "The article cited is an audio file."
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D001877",
    "display": "Book",
    "definition": "Non-periodical written or printed works consisting of sheets of pages fastened or bound together within covers."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "cds-artifact",
    "display": "Clinical Decision Support Artifact",
    "definition": "The artifact is used for decision support for healthcare decisions."
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D016420",
    "display": "Comment",
    "definition": "Comment"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "common-share",
    "display": "Common Share",
    "definition": "Citation Resource containing value added data that is openly shared"
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D019991",
    "display": "Database",
    "definition": "A structured file of information or a set of logically related data stored and retrieved using computer-based means."
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D064886",
    "display": "Dataset",
    "definition": "Works consisting of organized collections of data, which have been stored permanently in a formalized manner suitable for communication, interpretation, or processing."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "dataset-unpublished",
    "display": "Dataset Unpublished",
    "definition": "An organized collection of data that is not stored permanently for communication."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "Electronic",
    "display": "Electronic",
    "definition": "the journal is published in electronic format only"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "Electronic-eCollection",
    "display": "Electronic-eCollection",
    "definition": "used for electronic-only journals that publish individual articles first and then later collect them into an \"issue\" date that is typically called an eCollection."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "Electronic-Print",
    "display": "Electronic-Print",
    "definition": "the journal is published first in electronic format followed by print (this value is currently used for just one journal, Nucleic Acids Research)"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "executable-app",
    "display": "Executable app",
    "definition": "Executable app"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "fhir-resource",
    "display": "FHIR Resource",
    "definition": "The article cited is a FHIR resource."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "image",
    "display": "Image file",
    "definition": "The article cited is an image file."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "interactive-form",
    "display": "Interactive Form",
    "definition": "A user interface that supports data entry and data display."
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D016428",
    "display": "Journal Article",
    "definition": "Journal Article"
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D016422",
    "display": "Letter",
    "definition": "Letter"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "machine-code",
    "display": "Machine code",
    "definition": "The article cited is machine code."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "medline-base",
    "display": "Medline Base",
    "definition": "Citation Resource containing only data from Medline"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "prediction-model",
    "display": "Prediction Model",
    "definition": "A formula or expression used to calculate an outcome representing a predicted result."
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D000076942",
    "display": "Preprint",
    "definition": "Scientific manuscript made available prior to PEER REVIEW."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "Print",
    "display": "Print",
    "definition": "the journal is published in print format only"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "Print-Electronic",
    "display": "Print Electronic",
    "definition": "the journal is published in both print and electronic format"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "project-specific",
    "display": "Project Specific",
    "definition": "Citation Resource containing value added data specific to a project"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "protocol",
    "display": "Protocol",
    "definition": "The article cited is the protocol of an activity and not the results or findings."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "pseudocode",
    "display": "PseudoCode",
    "definition": "A non-executable, human-readable representation of software code."
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D016425",
    "display": "Published Erratum",
    "definition": "Published Erratum"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "standard-specification",
    "display": "Standard Specification",
    "definition": "An explicit set of requirements for an item, material, component, system or service, often used to define a technical standard which is an established norm or requirement for a repeatable technical task."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "terminology",
    "display": "Terminology",
    "definition": "A structured set of codes and display values, which may be subtyped as a code system, value set, taxonomy, or ontology."
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D059040",
    "display": "Video-Audio Media",
    "definition": "Used with articles which include video files or clips, or for articles which are entirely video."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-artifact-classifier",
    "code": "webpage",
    "display": "Webpage",
    "definition": "Webpage"
  }
]

const citationClassificationTypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-classification-type",
    "code": "citation-source",
    "display": "Citation Source",
    "definition": "Citation repository where this citation was created or copied from"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-classification-type",
    "code": "medline-owner",
    "display": "MEDLINE Citation Owner",
    "definition": "The party responsible for creating and validating the MEDLINE citation"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-classification-type",
    "code": "fevir-platform-use",
    "display": "FEvIR Platform Use",
    "definition": "Used for Citation sharing on the Fast Evidence Interoperability Resources (FEvIR) Platform"
  }
]

const citationSummaryStyleValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "vancouver",
    "display": "Vancouver style",
    "definition": "Citation style used by International Committee of Medical Journal Editors and maintained by US National Library of Medicine."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "ama11",
    "display": "American Medical Association 11th edition",
    "definition": "Medicine."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "apa7",
    "display": "American Psychological Association 7th edition",
    "definition": "APA 7th edition (October 2019) used by Education, Psychology and Sciences."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "apa6",
    "display": "American Psychological Association 6th edition",
    "definition": "APA 6th edition used by Education, Psychology and Sciences."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "asa6",
    "display": "American Sociological Association 6th edition",
    "definition": "Sociology."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "mla8",
    "display": "Modern Language Association 8th edition",
    "definition": "MLA 8th edition used by the Humanities."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "cochrane",
    "display": "Cochrane Style",
    "definition": "Used by Cochrane reviews, example: Huang, M, Tang T, Pang, P, Li, M, Ma R, Lu, J, et al. Treating COVID-19 with Chloroquine. J Mol Cell Biol 2020; 12(4):322–5."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "elsevier-harvard",
    "display": "Elsevier-Harvard Style",
    "definition": "Biology ecology."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "nature",
    "display": "Nature Referencing style",
    "definition": "Biology."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "acs",
    "display": "American Chemical Society",
    "definition": "Chemistry."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "chicago-a-17",
    "display": "Chicago Style Version 17 Author Date",
    "definition": "Used by Business, History and the Fine Arts."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "chicago-b-17",
    "display": "Chicago Style Version 17 Full note",
    "definition": "Used by Business, History and the Fine Arts."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "ieee",
    "display": "Institute of Electrical and Electronics Engineers",
    "definition": "IT, Engineering."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/citation-summary-style",
    "code": "comppub",
    "display": "Computable Publishing",
    "definition": "Citation style to report human-readable and/or machine-readable access paths, example: Alper BS, Dehnbostel J, Shahin K. 14-day mortality remdesivir vs placebo meta-analysis (ACTT-1, Wang et al, WHO SOLIDARITY).  Fast Evidence Interoperability Resources (FEvIR) Platform, entry 55, version 4. Created 2020 Dec 17. Revised 2020 Dec 21. Accessed 2021 Mar 13. Computable resource at: https://fevir.net/resources/Evidence/55."
  }
];

const citedArtifactAbstractTypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-abstract-type",
    "code": "primary-human-use",
    "display": "Primary human use",
    "definition": "Human-friendly main or official abstract"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-abstract-type",
    "code": "primary-machine-use",
    "display": "Primary machine use",
    "definition": "Machine-friendly main or official abstract"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-abstract-type",
    "code": "truncated",
    "display": "Truncated",
    "definition": "Truncated abstract"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-abstract-type",
    "code": "short-abstract",
    "display": "Short abstract",
    "definition": "Brief abstract, for use when abstracts are provided in different sizes or lengths"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-abstract-type",
    "code": "long-abstract",
    "display": "Long abstract",
    "definition": "Long version of the abstract, for use when abstracts are provided in different sizes or lengths"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-abstract-type",
    "code": "plain-language",
    "display": "Plain language",
    "definition": "Additional form of abstract written for the general public"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-abstract-type",
    "code": "different-publisher",
    "display": "Different publisher for abstract",
    "definition": "Abstract produced by a different publisher than the cited artifact"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-abstract-type",
    "code": "language",
    "display": "Different language",
    "definition": "Additional form of abstract in a different language"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-abstract-type",
    "code": "autotranslated",
    "display": "Different language derived from autotranslation",
    "definition": "Machine translated form of abstract in a different language, language element codes the language into which it was translated by machine"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-abstract-type",
    "code": "duplicate-pmid",
    "display": "Different text in additional Medline entry",
    "definition": "Alternative form of abstract in two or more Medline entries"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-abstract-type",
    "code": "earlier-abstract",
    "display": "Different text in an earlier version",
    "definition": "Alternative form of abstract in an earlier version such as epub ahead of print"
  }
]

const citedArtifactClassificationTypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-classification-type",
    "code": "publication-type",
    "display": "Publication type",
    "definition": "Publication type"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-classification-type",
    "code": "mesh-heading",
    "display": "MeSH heading",
    "definition": "MeSH heading"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-classification-type",
    "code": "supplemental-mesh-protocol",
    "display": "Supplemental MeSH for Protocol",
    "definition": "Supplemental MeSH for Protocol"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-classification-type",
    "code": "supplemental-mesh-disease",
    "display": "Supplemental MeSH for Disease",
    "definition": "Supplemental MeSH for Disease"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-classification-type",
    "code": "supplemental-mesh-organism",
    "display": "Supplemental MeSH for Organism",
    "definition": "Supplemental MeSH for Organism"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-classification-type",
    "code": "keyword",
    "display": "Keyword",
    "definition": "Keyword"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-classification-type",
    "code": "citation-subset",
    "display": "Citation subset",
    "definition": "Citation subset"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-classification-type",
    "code": "chemical",
    "display": "Chemical",
    "definition": "Chemical"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-classification-type",
    "code": "publishing-model",
    "display": "Publishing Model",
    "definition": "Used for PubModel attribute in Medline"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-classification-type",
    "code": "knowledge-artifact-type",
    "display": "Knowledge Artifact Type",
    "definition": "Knowledge Artifact Type"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-classification-type",
    "code": "coverage",
    "display": "Coverage",
    "definition": "The spatial or temporal topic of the resource, spatial applicability of the resource, or jurisdiction under which the resource is relevant"
  }
]

const citedArtifactContributionTypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "conceptualization",
    "display": "Conceptualization",
    "definition": "Conceptualization (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "data-curation",
    "display": "Data curation",
    "definition": "Data curation (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "formal-analysis",
    "display": "Formal analysis",
    "definition": "Formal analysis (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "funding-acquisition",
    "display": "Funding acquisition",
    "definition": "Funding acquisition (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "investigation",
    "display": "Investigation",
    "definition": "Investigation (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "methodology",
    "display": "Methodology",
    "definition": "Methodology (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "project-administration",
    "display": "Project administration",
    "definition": "Project administration (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "resources",
    "display": "Resources",
    "definition": "Resources (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "software",
    "display": "Software",
    "definition": "Software (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "supervision",
    "display": "Supervision",
    "definition": "Supervision (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "validation",
    "display": "Validation",
    "definition": "Validation (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "visualization",
    "display": "Visualization",
    "definition": "Visualization (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "writing-original-draft",
    "display": "Writing - original draft",
    "definition": "Writing - original draft (see https://jats4r.org/credit-taxonomy)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-contribution-type",
    "code": "writing-review-editing",
    "display": "Writing - review & editing",
    "definition": "Writing - review & editing (see https://jats4r.org/credit-taxonomy)."
  }
]

const citedArtifactPartTypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-part-type",
    "code": "chapters",
    "display": "chapters",
    "definition": "Denotes specific chapter or chapters of an article or artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-part-type",
    "code": "pages",
    "display": "pages",
    "definition": "Denotes specific page or pages of an article or artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-part-type",
    "code": "sections",
    "display": "sections",
    "definition": "Denotes specific section or sections of an article or artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-part-type",
    "code": "paragraphs",
    "display": "paragraphs",
    "definition": "Denotes specific paragraph or paragraphs of an article or artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-part-type",
    "code": "lines",
    "display": "lines",
    "definition": "Denotes specific line or lines of an article or artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-part-type",
    "code": "tables",
    "display": "tables",
    "definition": "Denotes specific table or tables of an article or artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-part-type",
    "code": "figures",
    "display": "figures",
    "definition": "Denotes specific figure or figures of an article or artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-part-type",
    "code": "supplement",
    "display": "Supplement or Appendix",
    "definition": "Used to denote a supplementary file, appendix, or additional part that is not a subpart of the primary article."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-part-type",
    "code": "supplement-subpart",
    "display": "Supplement or Appendix Subpart",
    "definition": "Used to denote a subpart within a supplementary file or appendix."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-part-type",
    "code": "article-set",
    "display": "Part of an article set",
    "definition": "Used to distinguish an individual article within an article set where the article set is a base citation."
  }
]

const citedArtifactStatusTypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "created",
    "display": "Created",
    "definition": "The content was originally constructed or composed."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "submitted",
    "display": "Submitted",
    "definition": "The content was sent to the publisher for consideration of publication."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "withdrawn",
    "display": "Withdrawn",
    "definition": "The content that was not published has been removed from consideration for publishing by the submitter."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "pre-review",
    "display": "Pre review",
    "definition": "The content is awaiting assignment and delivery to reviewer(s)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "under-review",
    "display": "Under review",
    "definition": "The content is in a state of being reviewed."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "post-review-pre-published",
    "display": "Post review pre published",
    "definition": "The content is in a state between the review(s) being completed and being published."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "rejected",
    "display": "Rejected",
    "definition": "The content that was not published has been removed from consideration for publishing by a publisher or editor."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "published-early-form",
    "display": "Published early form",
    "definition": "The content is published but future changes to the published version are expected."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "published-final-form",
    "display": "Published final form",
    "definition": "The content is published and further changes to the content are not expected."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "accepted",
    "display": "Accepted",
    "definition": "The content that was not published yet has been approved for publication by the publisher and/or editor."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "archived",
    "display": "Archived",
    "definition": "The content is retired or considered no longer current but still available as part of the public record."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "retracted",
    "display": "Retracted",
    "definition": "The content that was published is removed from publication and should no longer be considered part of the public record."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "draft",
    "display": "Draft",
    "definition": "The content is considered unfinished or incomplete and not representative of the current state desired by the content creator."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "active",
    "display": "Active",
    "definition": "The content is considered complete for its current state by the content creator."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "approved",
    "display": "Approved",
    "definition": "The content has been approved for a state transition, with the focus of approval described in the text associated with this coding."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "unknown",
    "display": "Unknown",
    "definition": "The status of the content is not recorded in the metadata."
  }
]

const fevirPublicationStatusValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "retracted",
    "display": "Retracted",
    "definition": "The content that was published is removed from publication and should no longer be considered part of the public record."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "draft",
    "display": "Draft",
    "definition": "The content is considered unfinished or incomplete and not representative of the current state desired by the content creator."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
    "code": "active",
    "display": "Active",
    "definition": "The content is considered complete for its current state by the content creator."
  }
]

const fevirPublicationStatusRetracted = {
  "coding": [
    {
      "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
      "code": "retracted",
      "display": "Retracted"
    }
  ]
};

const fevirPublicationStatusDraft = {
  "coding": [
    {
      "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
      "code": "draft",
      "display": "Draft"
    }
  ]
};

const fevirPublicationStatusActive = {
  "coding": [
    {
      "system": "http://terminology.hl7.org/CodeSystem/cited-artifact-status-type",
      "code": "active",
      "display": "Active"
    }
  ]
};

const citedMediumValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-medium",
    "code": "internet",
    "display": "Internet",
    "definition": "Online publication in a periodic release. Used to match NLM JournalIssue CitedMedium code for online version."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-medium",
    "code": "print",
    "display": "Print",
    "definition": "Print publication in a periodic release. Used to match NLM JournalIssue CitedMedium code for print version."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-medium",
    "code": "offline-digital-storage",
    "display": "Offline Digital Storage",
    "definition": "Publication in a physical device for electronic data storage, organized in issues for periodic release."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-medium",
    "code": "internet-without-issue",
    "display": "Internet without issue",
    "definition": "Online publication without any periodic release. Used for article specific publication date which could be the same as or different from journal issue publication date."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-medium",
    "code": "print-without-issue",
    "display": "Print without issue",
    "definition": "Print publication without any periodic release."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/cited-medium",
    "code": "offline-digital-storage-without-issue",
    "display": "Offline Digital Storage without issue",
    "definition": "Publication in a physical device for electronic data storage, without any periodic release."
  }
]

const commonUCUMUnitsValueSet = [
  {
    "system": "http://unitsofmeasure.org",
    "code": "%",
    "display": "percent"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "%/100",
    "display": "percent / 100"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "%[slope]",
    "display": "percent of slope"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/(12.h)",
    "display": "per 12 * hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/(2.h)",
    "display": "per 2 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/10*10",
    "display": "PerTenGiga"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/10*12",
    "display": "PerTrillion"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/10*3",
    "display": "per thousand"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/10*4",
    "display": "per 10 thousand"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/10*6",
    "display": "PerMillion"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/10*9",
    "display": "PerBillion"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/100",
    "display": "per 100"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/100.g",
    "display": "per 100 gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/L",
    "display": "per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/U",
    "display": "per enzyme unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/[HPF]",
    "display": "per high power field"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/[HPF]",
    "display": "per hpf"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/[IU]",
    "display": "per international unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/[LPF]",
    "display": "per low power field"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/[LPF]",
    "display": "per LPF"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/[arb'U]",
    "display": "per arbitrary unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/[iU]",
    "display": "per international unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/a",
    "display": "/ year"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/cm[H2O]",
    "display": "per centimeter of water"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/d",
    "display": "per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/dL",
    "display": "per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/g",
    "display": "per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/h",
    "display": "per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/kg",
    "display": "per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/m2",
    "display": "per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/m3",
    "display": "per cubic meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/mL",
    "display": "per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/mg",
    "display": "per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/min",
    "display": "per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/min/10*3",
    "display": "per minute per thousand"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/mm",
    "display": "per millimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/mm3",
    "display": "per cubic millimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/mmol",
    "display": "per millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/mo",
    "display": "per month"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/s",
    "display": "per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/uL",
    "display": "per microliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/ug",
    "display": "per microgram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "/wk",
    "display": "per week"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "1",
    "display": "1*"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "1/d",
    "display": "one per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "1/min",
    "display": "one per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*",
    "display": "the number ten for arbitrary powers"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*-3",
    "display": "(the number ten for arbitrary powers ^ -3)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*-6",
    "display": "the number ten for arbitrary powers ^ -6"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*12/L",
    "display": "trillion per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*3",
    "display": "Thousand"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*3.U",
    "display": "Thousand Per * Unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*3/L",
    "display": "Thousand Per Liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*3/mL",
    "display": "Thousand Per MilliLiter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*3/uL",
    "display": "Thousands Per MicroLiter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*4/uL",
    "display": "10 thousand per microliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*5",
    "display": "OneHundredThousand"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6",
    "display": "Million"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6.U",
    "display": "(the number ten for arbitrary powers ^ 6) * Unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6.[CFU]/L",
    "display": "million colony forming unit per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6.[IU]",
    "display": "million international unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6.[iU]",
    "display": "MillionInternationalUnit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6.eq/mL",
    "display": "MillionEquivalentsPerMilliLiter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6/(24.h)",
    "display": "million per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6/L",
    "display": "million per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6/kg",
    "display": "million per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6/mL",
    "display": "million per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6/mm3",
    "display": "(the number ten for arbitrary powers ^ 6) / (millimeter ^ 3)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*6/uL",
    "display": "million per microliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*8",
    "display": "TenToEighth"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*9/L",
    "display": "billion per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*9/mL",
    "display": "billion per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10*9/uL",
    "display": "billion per microliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10.L/(min.m2)",
    "display": "10 liter per minute per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10.L/min",
    "display": "10 liter per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10.uN.s/(cm.m2)",
    "display": "10 * microNewton * second / centimeter * (meter ^ 2)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10.uN.s/(cm5.m2)",
    "display": "10 micronewton second per centimeter to the fifth power per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10.uN.s/cm",
    "display": "10 * microNewton * second / centimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10.uN.s/cm2",
    "display": "10 * microNewton * second / (centimeter ^ 2)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "10^",
    "display": "the number ten for arbitrary powers"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "24.h",
    "display": "24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "A",
    "display": "Ampère"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "A/m",
    "display": "Ampère / meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "AU",
    "display": "astronomic unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Ao",
    "display": "Ångström"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "B",
    "display": "bel"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "B[SPL]",
    "display": "bel sound pressure"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "B[V]",
    "display": "bel volt"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "B[W]",
    "display": "bel watt"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "B[kW]",
    "display": "bel kilowatt"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "B[mV]",
    "display": "bel millivolt"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "B[uV]",
    "display": "bel microvolt"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Bd",
    "display": "baud"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Bi",
    "display": "Biot"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Bq",
    "display": "Becquerel"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "By",
    "display": "byte"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "C",
    "display": "Coulomb"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Cel",
    "display": "degree Celsius"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Ci",
    "display": "CURIE"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "F",
    "display": "Farad"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "G",
    "display": "Gauss"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "GBq",
    "display": "gigaBecquerel"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Gal",
    "display": "Gal"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Gb",
    "display": "Gilbert"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Gy",
    "display": "Gray"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "H",
    "display": "Henry"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Hz",
    "display": "Hertz"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "J",
    "display": "joule"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "J/L",
    "display": "joule per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "K",
    "display": "Kelvin"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "K/W",
    "display": "Kelvin / Watt"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Ky",
    "display": "Kayser"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L",
    "display": "liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L.s2/s",
    "display": "liter * (second ^ 2) / second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L/(24.h)",
    "display": "liter per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L/(8.h)",
    "display": "liter per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L/(min.m2)",
    "display": "liter per minute per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L/L",
    "display": "liter per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L/d",
    "display": "liter per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L/h",
    "display": "liter per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L/kg",
    "display": "liter per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L/min",
    "display": "liter per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L/s",
    "display": "liter / second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "L/s/s2",
    "display": "liter per second per square second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Lmb",
    "display": "Lambert"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "MBq",
    "display": "megaBecquerel"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Ms",
    "display": "megasecond"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Mx",
    "display": "Maxwell"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "N",
    "display": "Newton"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "N.cm",
    "display": "Newton centimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "N.s",
    "display": "Newton second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Np",
    "display": "neper"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Oe",
    "display": "Oersted"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Ohm",
    "display": "Ohm"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Ohm.m",
    "display": "Ohm meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "P",
    "display": "Poise"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Pa",
    "display": "Pascal"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "R",
    "display": "Roentgen"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "RAD",
    "display": "radiation absorbed dose"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "REM",
    "display": "radiation equivalent man"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "S",
    "display": "Siemens"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "St",
    "display": "Stokes"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Sv",
    "display": "Sievert"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "T",
    "display": "Tesla"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U",
    "display": "enzyme Unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/(1.h)",
    "display": "enzyme Unit per 1 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/(10.g)",
    "display": "enzyme unit per 10 gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/(12.h)",
    "display": "enzyme unit per 12 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/(18.h)",
    "display": "enzyme Unit per 18 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/(2.h)",
    "display": "enzyme unit per 2 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/(24.h)",
    "display": "enzyme unit per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/10",
    "display": "enzyme unit per 10"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/10*10",
    "display": "enzyme unit per 10 billion"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/10*12",
    "display": "enzyme unit per trillion"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/10*12",
    "display": "enzyme unit per trillion"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/10*6",
    "display": "enzyme unit per million"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/10*9",
    "display": "enzyme unit per billion"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/L",
    "display": "enzyme unit per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/d",
    "display": "enzyme unit per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/dL",
    "display": "enzyme unit per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/g",
    "display": "enzyme unit per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/h",
    "display": "enzyme unit per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/kg",
    "display": "enzyme unit per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/kg/h",
    "display": "Unit / kilogram / hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/mL",
    "display": "enzyme unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/min",
    "display": "enzyme unit per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/mmol",
    "display": "enzyme unit per millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/mol",
    "display": "enzyme Unit per mole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/s",
    "display": "enzyme unit per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "U/umol",
    "display": "enzyme Unit per micromole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "V",
    "display": "volt"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "W",
    "display": "Watt"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "Wb",
    "display": "Weber"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[APL'U]",
    "display": "IgA anticardiolipin unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[APL'U]/mL",
    "display": "IgA anticardiolipin unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[AU]",
    "display": "allergy unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[Amb'a'1'U]",
    "display": "Amb a 1 units"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[BAU]",
    "display": "bioequivalent allergen unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[Btu]",
    "display": "British thermal unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[Btu_39]",
    "display": "British thermal unit at 39 °F"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[Btu_59]",
    "display": "British thermal unit at 59 °F"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[Btu_60]",
    "display": "British thermal unit at 60 °F"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[Btu_IT]",
    "display": "international table British thermal unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[Btu_m]",
    "display": "mean British thermal unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[Btu_th]",
    "display": "thermochemical British thermal unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[CCID_50]",
    "display": "CELL CULTURE INFECTIOUS DOSE 50%"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[CFU]",
    "display": "colony forming unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[CFU]/L",
    "display": "colony forming unit per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[CFU]/mL",
    "display": "colony forming unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[Cal]",
    "display": "nutrition label Calories"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[Ch]",
    "display": "French (catheter gauge)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[D'ag'U]",
    "display": "D-ANTIGEN UNITS"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[FFU]",
    "display": "FOCUS-FORMING UNITS"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[GPL'U]",
    "display": "IgG anticardiolipin unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[GPL'U]/mL",
    "display": "IgG anticardiolipin unit per milliliter**"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[G]",
    "display": "Newtonian constant of gravitation"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[HPF]",
    "display": "high power field"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[HP]",
    "display": "horsepower"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]",
    "display": "international unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/(2.h)",
    "display": "international unit per 2 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/(24.h)",
    "display": "international unit per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/10*9",
    "display": "international unit per billion"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/L",
    "display": "international unit per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/d",
    "display": "international unit per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/dL",
    "display": "international unit per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/g",
    "display": "international unit per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/h",
    "display": "international unit per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/kg",
    "display": "international unit per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/kg/d",
    "display": "international unit per kilogram per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/mL",
    "display": "international unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[IU]/min",
    "display": "international unit per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[LPF]",
    "display": "low power field"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[Lf]",
    "display": "LIMIT OF FLOCCULATION"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[MET]",
    "display": "metabolic equivalent"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[MPL'U]",
    "display": "IgM anticardiolipin unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[MPL'U]/mL",
    "display": "IgM anticardiolipin unit per milliliter**"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[PFU]",
    "display": "PLAQUE-FORMING UNITS"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[PNU]",
    "display": "PROTEIN NITROGEN UNITS"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[PRU]",
    "display": "peripheral vascular resistance unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[S]",
    "display": "Svedberg unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[TCID_50]",
    "display": "TISSUE CULTURE INFECTIOUS DOSE 50%"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[USP'U]",
    "display": "UNITED STATES PHARMACOPEIA UNIT"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[acr_br]",
    "display": "acre"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[acr_us]",
    "display": "acre"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[arb'U]",
    "display": "arbitrary unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[arb'U]/L",
    "display": "arbitary unit / liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[arb'U]/mL",
    "display": "arbitrary unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[bbl_us]",
    "display": "barrel"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[bdsk'U]",
    "display": "Bodansky unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[beth'U]",
    "display": "Bethesda unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[beth'U]",
    "display": "Bethesda unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[bf_i]",
    "display": "board foot"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[bu_br]",
    "display": "bushel"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[bu_us]",
    "display": "bushel"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[c]",
    "display": "velocity of light"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[car_Au]",
    "display": "carat of gold alloys"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[car_m]",
    "display": "metric carat"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[cft_i]",
    "display": "cubic foot"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ch_br]",
    "display": "Gunter's chain"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ch_us]",
    "display": "Gunter's chain Surveyor's chain"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[cicero]",
    "display": "cicero Didot's pica"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[cin_i]",
    "display": "cubic inch"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[cml_i]",
    "display": "circular mil"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[cr_i]",
    "display": "cord"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[crd_us]",
    "display": "cord"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[cup_us]",
    "display": "cup"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[cyd_i]",
    "display": "cubic yard"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[degF]",
    "display": "degree Fahrenheit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[didot]",
    "display": "didot Didot's point"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[diop]",
    "display": "diopter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[dpt_us]",
    "display": "dry pint"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[dqt_us]",
    "display": "dry quart"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[dr_ap]",
    "display": "dram drachm"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[dr_av]",
    "display": "Dram (US and British)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[drp]",
    "display": "drop"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[drp]/[HPF]",
    "display": "drop / HPF"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[drp]/h",
    "display": "drop / hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[drp]/mL",
    "display": "drop / milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[drp]/min",
    "display": "drop / minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[drp]/s",
    "display": "drop / second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[dye'U]",
    "display": "Dye unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[e]",
    "display": "elementary charge"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[eps_0]",
    "display": "permittivity of vacuum"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[fdr_br]",
    "display": "fluid dram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[fdr_us]",
    "display": "fluid dram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[foz_br]",
    "display": "fluid ounce"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[foz_us]",
    "display": "fluid ounce"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ft_br]",
    "display": "foot"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ft_i]",
    "display": "Feet"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ft_us]",
    "display": "foot"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[fth_br]",
    "display": "fathom"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[fth_i]",
    "display": "fathom"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[fth_us]",
    "display": "fathom"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[fur_us]",
    "display": "furlong"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[gal_br]",
    "display": "gallon"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[gal_us]",
    "display": "Queen Anne's wine gallon"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[gal_wi]",
    "display": "historical winchester gallon"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[gil_br]",
    "display": "gill"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[gil_us]",
    "display": "gill"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[gr]",
    "display": "grain"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[h]",
    "display": "Planck constant"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[hd_i]",
    "display": "hand"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[hnsf'U]",
    "display": "Hounsfield unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[hp_C]",
    "display": "HOMEOPATHIC POTENCY OF CENTESIMAL SERIES"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[hp_M]",
    "display": "HOMEOPATHIC POTENCY OF MILLESIMAL SERIES"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[hp_Q]",
    "display": "HOMEOPATHIC POTENCY OF QUINTAMILLESIMAL SERIES"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[hp_X]",
    "display": "HOMEOPATHIC POTENCY OF DECIMAL SERIES"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[iU]",
    "display": "international unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[iU]",
    "display": "international unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[iU]/L",
    "display": "InternationalUnitsPerLiter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[iU]/dL",
    "display": "InternationalUnitsPerDeciLiter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[iU]/g",
    "display": "InternationalUnitsPerGram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[iU]/kg",
    "display": "InternationalUnitsPerKilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[iU]/mL",
    "display": "InternationalUnitsPerMilliLiter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[in_br]",
    "display": "inch"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[in_i'H2O]",
    "display": "inch (international) of water"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[in_i'Hg]",
    "display": "inch of mercury column"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[in_i]",
    "display": "inch (international)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[in_us]",
    "display": "inch"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[k]",
    "display": "Boltzmann constant"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ka'U]",
    "display": "King Armstrong unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[kn_br]",
    "display": "knot"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[kn_i]",
    "display": "knot"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[knk'U]",
    "display": "Kunkel unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[kp_C]",
    "display": "HOMEOPATHIC POTENCY OF CENTESIMAL KORSAKOVIAN SERIES"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[lb_ap]",
    "display": "pound"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[lb_av]",
    "display": "pound (US and British)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[lb_tr]",
    "display": "pound"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[lbf_av]",
    "display": "pound force"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[lcwt_av]",
    "display": "long hunderdweight British hundredweight"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ligne]",
    "display": "ligne French line"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[lk_br]",
    "display": "link for Gunter's chain"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[lk_us]",
    "display": "link for Gunter's chain"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[lne]",
    "display": "line"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[lton_av]",
    "display": "long ton British ton"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ly]",
    "display": "light-year"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[m_e]",
    "display": "electron mass"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[m_p]",
    "display": "proton mass"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[mclg'U]",
    "display": "Mac Lagan unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[mesh_i]",
    "display": "mesh"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[mi_br]",
    "display": "mile"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[mi_i]",
    "display": "statute mile"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[mi_us]",
    "display": "mile"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[mil_i]",
    "display": "mil"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[mil_us]",
    "display": "mil"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[min_br]",
    "display": "minim"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[min_us]",
    "display": "minim"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[mu_0]",
    "display": "permeability of vacuum"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[nmi_br]",
    "display": "nautical mile"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[nmi_i]",
    "display": "nautical mile"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[oz_ap]",
    "display": "ounce (US and British)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[oz_av]",
    "display": "ounce (US and British)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[oz_tr]",
    "display": "ounce"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[p'diop]",
    "display": "prism diopter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pH]",
    "display": "pH"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pc_br]",
    "display": "pace"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pca]",
    "display": "pica"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pca_pr]",
    "display": "Printer's pica"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pi]",
    "display": "the number pi"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pi].rad/min",
    "display": "the number pi * radian / minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pied]",
    "display": "pied French foot"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pk_br]",
    "display": "peck"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pk_us]",
    "display": "peck"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pnt]",
    "display": "point"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pnt_pr]",
    "display": "Printer's point"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pouce]",
    "display": "pouce French inch"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ppb]",
    "display": "part per billion"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ppm]",
    "display": "part per million"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ppth]",
    "display": "parts per thousand"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pptr]",
    "display": "part per trillion"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pptr]",
    "display": "parts per trillion"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[psi]",
    "display": "pound per square inch"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pt_br]",
    "display": "pint"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pt_us]",
    "display": "pint"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[pwt_tr]",
    "display": "pennyweight"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[qt_br]",
    "display": "quart"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[qt_us]",
    "display": "quart"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[rch_us]",
    "display": "Ramden's chain Engineer's chain"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[rd_br]",
    "display": "rod"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[rd_us]",
    "display": "rod"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[rlk_us]",
    "display": "link for Ramden's chain"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[sc_ap]",
    "display": "scruple"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[sct]",
    "display": "section"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[scwt_av]",
    "display": "short hundredweight U.S. hundredweight"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[sft_i]",
    "display": "square foot (international)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[sin_i]",
    "display": "square inch (international)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[smgy'U]",
    "display": "Somogyi unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[smi_us]",
    "display": "square mile"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[smoot]",
    "display": "Smoot"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[srd_us]",
    "display": "square rod"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[ston_av]",
    "display": "short ton U.S. ton"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[stone_av]",
    "display": "stone British stone"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[syd_i]",
    "display": "square yard"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[tb'U]",
    "display": "tuberculin unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[tbs_us]",
    "display": "tablespoon (US)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[todd'U]",
    "display": "Todd unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[todd'U]",
    "display": "Todd unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[tsp_us]",
    "display": "teaspoon"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[twp]",
    "display": "township"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[yd_br]",
    "display": "yard"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[yd_i]",
    "display": "yard"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "[yd_us]",
    "display": "yard"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "a",
    "display": "year"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "a_g",
    "display": "mean Gregorian year"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "a_j",
    "display": "mean Julian year"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "a_t",
    "display": "tropical year"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ag",
    "display": "attogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ar",
    "display": "are"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "atm",
    "display": "standard atmosphere"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "att",
    "display": "technical atmosphere"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "b",
    "display": "barn"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "bar",
    "display": "bar"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "bit",
    "display": "bit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "bit_s",
    "display": "bit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cL",
    "display": "centiliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cP",
    "display": "centiPoise"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cSt",
    "display": "centiStokes"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cal",
    "display": "calorie"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cal_IT",
    "display": "international table calorie"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cal_[15]",
    "display": "calorie at 15 °C"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cal_[20]",
    "display": "calorie at 20 °C"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cal_m",
    "display": "mean calorie"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cal_th",
    "display": "thermochemical calorie"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cd",
    "display": "candela"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cg",
    "display": "centigram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "circ",
    "display": "circle"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cm",
    "display": "centimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cm2",
    "display": "square centimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cm2/s",
    "display": "square centimeter per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cm3",
    "display": "cubic centimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cm[H2O]",
    "display": "centimeter of water"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cm[H2O]/(s.m)",
    "display": "centimeter of water column / second * meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cm[H2O]/L/s",
    "display": "centimeter of water per liter per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cm[H2O]/s/m",
    "display": "centimeter of water per second per meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "cm[Hg]",
    "display": "centimeter of mercury"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "d",
    "display": "day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "dB",
    "display": "decibel"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "dL",
    "display": "deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "daL/min",
    "display": "dekaliter per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "daL/min/m2",
    "display": "dekaliter per minute per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "deg",
    "display": "degree"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "deg/s",
    "display": "degree per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "dg",
    "display": "decigram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "dm",
    "display": "decimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "dm2/s2",
    "display": "square decimeter per square second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "dyn",
    "display": "dyne"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "dyn.s/(cm.m2)",
    "display": "dyne second per centimeter per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "dyn.s/cm",
    "display": "dyne second per centimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "eV",
    "display": "electronvolt"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "eq",
    "display": "equivalents"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "eq/L",
    "display": "equivalents / liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "eq/mL",
    "display": "equivalents / milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "eq/mmol",
    "display": "equivalents / millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "eq/umol",
    "display": "equivalents / micromole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "erg",
    "display": "erg"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "fL",
    "display": "femtoliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "fL/nL",
    "display": "femtoliter / nanoliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "fg",
    "display": "femtogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "fm",
    "display": "femtometer"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "fmol",
    "display": "femtomole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "fmol/L",
    "display": "femtomole per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "fmol/g",
    "display": "femtomole per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "fmol/mL",
    "display": "femtomole / milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "fmol/mg",
    "display": "femtomole / milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "fmol/mg",
    "display": "femtomole per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g",
    "display": "gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g%",
    "display": "gram percent"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g.m",
    "display": "gram * meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(100.g)",
    "display": "gram per 100 gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(12.h)",
    "display": "gram per 12 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(24.h)",
    "display": "gram per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(3.d)",
    "display": "gram per 3 days"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(4.h)",
    "display": "gram per 4 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(48.h)",
    "display": "gram per 48 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(5.h)",
    "display": "gram per 5 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(6.h)",
    "display": "gram per 6 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(72.h)",
    "display": "gram per 72 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(8.h)",
    "display": "gram / 8 * hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(8.kg.h)",
    "display": "gram / 8 * kilogram * hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(kg.h)",
    "display": "gram / kilogram * hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/(kg.min)",
    "display": "gram / kilogram * minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/L",
    "display": "gram per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/cm3",
    "display": "gram per cubic centimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/d",
    "display": "gram per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/dL",
    "display": "gram per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/g",
    "display": "gram per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/h",
    "display": "gram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/h/m2",
    "display": "gram per hour per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/kg",
    "display": "gram per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/kg/(8.h)",
    "display": "gram per  kilogram per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/kg/d",
    "display": "gram per kilogram per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/kg/h",
    "display": "gram per kilogram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/kg/min",
    "display": "gram per kilogram per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/m2",
    "display": "grams Per Square Meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/mL",
    "display": "gram per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/mg",
    "display": "gram per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/min",
    "display": "gram per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/mmol",
    "display": "gram per millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "g/mol",
    "display": "gram per mole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "gf",
    "display": "gram-force"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "gon",
    "display": "gon grade"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "h",
    "display": "hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "hL",
    "display": "hectoliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kBq",
    "display": "kiloBecquerel"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kL",
    "display": "kiloliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kPa",
    "display": "kiloPascal"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kU",
    "display": "kilo enzyme unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kU/L",
    "display": "kiloenzyme Unit per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kU/g",
    "display": "kiloenzyme Unit per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kU/h",
    "display": "kiloUnit / hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kU/mL",
    "display": "kilo enzyme unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "k[IU]/L",
    "display": "kilo international unit per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "k[IU]/mL",
    "display": "kilo international unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "k[iU]/mL",
    "display": "KiloInternationalUnitsPerMilliLiter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kat",
    "display": "katal"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kat/L",
    "display": "katal / liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kat/kg",
    "display": "katal / kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kcal",
    "display": "kilocalorie"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kcal/(8.h)",
    "display": "kilocalorie / 8 * hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kcal/[oz_av]",
    "display": "kilocalorie per ounce (US & British)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kcal/d",
    "display": "kilocalorie per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kcal/h",
    "display": "kilocalorie per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kcal/kg/(24.h)",
    "display": "kilocalorie per kilogram per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kg",
    "display": "kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kg.m/s",
    "display": "kilogram meter per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kg/(s.m2)",
    "display": "kilogram per second per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kg/L",
    "display": "kilogram per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kg/h",
    "display": "kilogram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kg/m2",
    "display": "kilogram / (meter ^ 2)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kg/m3",
    "display": "kilogram / (meter ^ 3)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kg/min",
    "display": "kilogram / minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kg/mol",
    "display": "kilogram per mole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "kg/s",
    "display": "kilogram / second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "km",
    "display": "kilometer"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ks",
    "display": "kilosecond"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "lm",
    "display": "lumen"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "lm.m2",
    "display": "lumen square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "lm/m2",
    "display": "lumen / (meter ^ 2)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "lx",
    "display": "lux"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "m",
    "display": "meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "m/s",
    "display": "meter per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "m/s2",
    "display": "meter per square second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "m2",
    "display": "square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "m2/s",
    "display": "square meter per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "m3/s",
    "display": "cubic meter per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mA",
    "display": "milliAmpère"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mCi",
    "display": "milliCurie"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL",
    "display": "milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/(10.h)",
    "display": "milliliter per 10 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/(12.h)",
    "display": "milliliter per 12 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/(2.h)",
    "display": "milliliter per 2 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/(24.h)",
    "display": "milliliter per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/(4.h)",
    "display": "milliliter per 4 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/(5.h)",
    "display": "milliliter per 5 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/(6.h)",
    "display": "milliliter per 6 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/(72.h)",
    "display": "milliliter per 72 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/(8.h)",
    "display": "milliliter per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/(kg.min)",
    "display": "milliliter / kilogram * minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/L",
    "display": "milliliter per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/[sin_i]",
    "display": "milliliter per square inch (international)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/cm[H2O]",
    "display": "milliliter / centimeter of water column"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/d",
    "display": "milliliter per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/dL",
    "display": "milliliter per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/h",
    "display": "milliliter per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/kg",
    "display": "milliliter per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/kg/(8.h)",
    "display": "milliliter per kilogram per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/kg/d",
    "display": "milliliter per kilogram per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/kg/h",
    "display": "milliliter per kilogram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/kg/min",
    "display": "milliliter per kilogram per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/m2",
    "display": "milliliter per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/mbar",
    "display": "milliliter per millibar"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/min",
    "display": "milliliter per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/min/(173.10*-2.m2)",
    "display": "milliliter / minute / 173 * (the number ten for arbitrary powers ^ -2) * (meter          ^ 2)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/min/1.73.m2",
    "display": "milliliter per minute per 1.73 square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/min/m2",
    "display": "milliliter per minute per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/mm",
    "display": "milliliter per millimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mL/s",
    "display": "milliliter per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mPa",
    "display": "millipascal"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mPa.s",
    "display": "millipascal second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mU",
    "display": "millienzyme Unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mU/L",
    "display": "millienzyme Unit per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mU/g",
    "display": "millienzyme Unit per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mU/mL",
    "display": "millienzyme Unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mU/mL/min",
    "display": "millienzyme Unit per milliliter per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mU/mg",
    "display": "milliUnit / milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mU/min",
    "display": "milliUnit / minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mU/mmol",
    "display": "millienzyme Unit per millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mV",
    "display": "milliVolt"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "m[H2O]",
    "display": "meter of water column"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "m[Hg]",
    "display": "meter of mercury column"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "m[IU]/L",
    "display": "milli international unit per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "m[IU]/mL",
    "display": "milli international unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "m[iU]",
    "display": "milliinternational unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mbar",
    "display": "millibar"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mbar.s/L",
    "display": "millibar second per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mbar/L/s",
    "display": "millibar per liter per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq",
    "display": "milliequivalent"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/(12.h)",
    "display": "milliequivalent per 12 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/(2.h)",
    "display": "milliequivalent per 2 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/(24.h)",
    "display": "milliequivalent per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/(8.h)",
    "display": "milliequivalent per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/(8.h.kg)",
    "display": "milliequivalents / 8 * hour * kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/(kg.d)",
    "display": "milliequivalents / kilogram * day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/L",
    "display": "milliequivalent per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/d",
    "display": "milliequivalent per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/dL",
    "display": "milliequivalent per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/g",
    "display": "milliequivalent per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/h",
    "display": "milliequivalent per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/kg",
    "display": "milliequivalent per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/kg/h",
    "display": "milliequivalent per kilogram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/kg/min",
    "display": "milliequivalents / kilogram / minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/m2",
    "display": "milliequivalent per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/mL",
    "display": "milliequivalent per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "meq/min",
    "display": "milliequivalent per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg",
    "display": "milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/(10.h)",
    "display": "milligram per 10 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/(12.h)",
    "display": "milligram per 12 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/(18.h)",
    "display": "milligram per 18 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/(2.h)",
    "display": "milligram per 2 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/(24.h)",
    "display": "milligram per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/(6.h)",
    "display": "milligram per 6 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/(72.h)",
    "display": "milligram per 72 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/(8.h)",
    "display": "milligram per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/(8.h.kg)",
    "display": "milligram / 8 * hour * kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/(kg.h)",
    "display": "milligram / kilogram * hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/L",
    "display": "milligram per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/d",
    "display": "milligram per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/d/(173.10*-2.m2)",
    "display": "milligram / day / 173 * (the number ten for arbitrary powers ^ -2) * (meter ^ 2)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/d/1.73.m2",
    "display": "milligram per day per 1.73 square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/dL",
    "display": "milligram per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/g",
    "display": "milligram per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/h",
    "display": "milligram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/kg",
    "display": "milligram per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/kg/(24.h)",
    "display": "milligram / kilogram / 24 * hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/kg/(8.h)",
    "display": "milligram per kilogram per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/kg/d",
    "display": "milligram per kilogram per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/kg/h",
    "display": "milligram per kilogram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/kg/min",
    "display": "milligram per kilogram per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/m2",
    "display": "milligram per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/m3",
    "display": "milligram per cubic meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/mL",
    "display": "milligram per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/mg",
    "display": "milligram per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/min",
    "display": "milligram per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/mmol",
    "display": "milligram per millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mg/wk",
    "display": "milligram per week"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mho",
    "display": "mho"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "min",
    "display": "minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mm",
    "display": "millimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mm/h",
    "display": "millimeter per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mm/min",
    "display": "millimeter per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mm2",
    "display": "square millimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mm3",
    "display": "cubic millimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mm[H2O]",
    "display": "millimeter of water"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mm[Hg]",
    "display": "millimeter of mercury"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol",
    "display": "millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/(12.h)",
    "display": "millimole per 12 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/(18.h)",
    "display": "millimole per 18 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/(2.h)",
    "display": "millimole per 2 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/(24.h)",
    "display": "millimole per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/(5.h)",
    "display": "millimole per 5 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/(6.h)",
    "display": "millimole per 6 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/(8.h)",
    "display": "millimole per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/(8.h.kg)",
    "display": "millimole / 8 * hour * kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/L",
    "display": "millimole per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/L/s",
    "display": "millimole per liter per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/d",
    "display": "millimole per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/dL",
    "display": "millimole per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/g",
    "display": "millimole per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/h",
    "display": "millimole per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/h/mg",
    "display": "millimole per hour per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/kg",
    "display": "millimole per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/kg/(8.h)",
    "display": "millimole per kilogram per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/kg/d",
    "display": "millimole per kilogram per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/kg/h",
    "display": "millimole per kilogram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/kg/min",
    "display": "millimole per kilogram per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/m",
    "display": "millimole / meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/m2",
    "display": "millimole per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/min",
    "display": "millimole per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/mmol",
    "display": "millimole per millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/mol",
    "display": "millimole per mole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mmol/s/L",
    "display": "millimole per second per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mo",
    "display": "month"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mo_g",
    "display": "mean Gregorian month"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mo_j",
    "display": "mean Julian month"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mo_s",
    "display": "synodal month"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mol",
    "display": "mole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mol/L",
    "display": "mole per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mol/d",
    "display": "mole per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mol/kg",
    "display": "mole per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mol/kg/s",
    "display": "mole per kilogram per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mol/m3",
    "display": "mole per cubic meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mol/mL",
    "display": "mole per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mol/mol",
    "display": "mole per mole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mol/s",
    "display": "mole per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mosm",
    "display": "milliosmole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mosm/L",
    "display": "milliosmole per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "mosm/kg",
    "display": "milliosmole per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ms",
    "display": "millisecond"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nCi",
    "display": "nanoCurie"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nL",
    "display": "nanoliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nU/mL",
    "display": "nanoenzyme unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nU",
    "display": "nanoenzyme unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng",
    "display": "nanogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/(24.h)",
    "display": "nanogram per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/(8.h)",
    "display": "nanogram per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/(8.h.kg)",
    "display": "nanogram / 8 * hour * kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/(kg.d)",
    "display": "nanogram / kilogram * day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/(kg.h)",
    "display": "nanogram / kilogram * hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/(kg.min)",
    "display": "nanogram / kilogram * minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/10*6",
    "display": "nanogram per million"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/L",
    "display": "nanogram per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/U",
    "display": "nanogram per enzyme unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/d",
    "display": "nanogram per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/dL",
    "display": "nanogram per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/dL/h",
    "display": "nanogram / deciliter / hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/g",
    "display": "nanogram per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/h",
    "display": "nanogram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/kg",
    "display": "nanogram per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/kg/(8.h)",
    "display": "nanogram per kilogram per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/kg/h",
    "display": "nanogram per kilogram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/kg/min",
    "display": "nanogram per kilogram per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/m2",
    "display": "nanogram per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/mL",
    "display": "nanogram per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/mL/h",
    "display": "nanogram per milliliter per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/mg",
    "display": "nanogram per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/mg/h",
    "display": "nanogram per milligram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/min",
    "display": "nanogram per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ng/s",
    "display": "nanogram per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nkat",
    "display": "nanokatal"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nm",
    "display": "nanometer"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nm/s/L",
    "display": "nanometer per second per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol",
    "display": "nanomole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/(24.h)",
    "display": "nanomole per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/L",
    "display": "nanomole per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/L/mmol",
    "display": "nanomole per liter per millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/L/s",
    "display": "nanomole per liter per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/d",
    "display": "nanomole per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/dL",
    "display": "nanomole per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/g",
    "display": "nanomole per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/h/L",
    "display": "nanomole per hour per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/h/mL",
    "display": "nanomole per hour per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/h/mg",
    "display": "nanomole per hour per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/m/mg",
    "display": "nanomole per meter per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/mL",
    "display": "nanomole per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/mL/h",
    "display": "nanomole per milliliter per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/mL/min",
    "display": "nanomole per milliliter per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/mg",
    "display": "nanomole per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/mg/h",
    "display": "nanomole per milligram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/min",
    "display": "nanomole per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/min/10*6",
    "display": "nanomole per minute per million"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/min/mL",
    "display": "nanomole per minute per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/min/mg",
    "display": "nanomole per minute per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/mmol",
    "display": "nanomole per millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/mol",
    "display": "nanomole per mole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/nmol",
    "display": "nanomole per nanomole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/s",
    "display": "nanomole per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "nmol/s/L",
    "display": "nanomole per second per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ns",
    "display": "nanosecond"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "osm",
    "display": "osmole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "osm/L",
    "display": "osmole per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "osm/kg",
    "display": "osmole per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pA",
    "display": "picoampere"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pL",
    "display": "picoliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pT",
    "display": "picotesla"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pc",
    "display": "parsec"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pg",
    "display": "picogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pg/L",
    "display": "picogram per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pg/dL",
    "display": "picogram per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pg/mL",
    "display": "picogram per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pg/mg",
    "display": "picogram per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pg/mm",
    "display": "picogram per millimeter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ph",
    "display": "phot"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pkat",
    "display": "picokatal"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pm",
    "display": "picometer"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol",
    "display": "picomole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/(24.h)",
    "display": "picomole per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/L",
    "display": "picomole per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/d",
    "display": "picomole per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/dL",
    "display": "picomole per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/g",
    "display": "picomole per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/h/mL",
    "display": "picomole per hour per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/h/mg",
    "display": "picomole per hour per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/mL",
    "display": "picomole per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/mg",
    "display": "picomole per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/min",
    "display": "picomole per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/min/mg",
    "display": "picomole per minute per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/mmol",
    "display": "picomole per millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/mol",
    "display": "picomole per mole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "pmol/umol",
    "display": "picomole per micromole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ps",
    "display": "picosecond"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "rad",
    "display": "radian"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "s",
    "display": "second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "sb",
    "display": "stilb"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "sph",
    "display": "spere"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "sr",
    "display": "steradian"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "st",
    "display": "stere"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "t",
    "display": "tonne"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "u",
    "display": "unified atomic mass unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "uCi",
    "display": "MICROCURIE"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "uL",
    "display": "microliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "uL/(2.h)",
    "display": "microliter per 2 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "uL/h",
    "display": "microliter per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "uOhm",
    "display": "microOhm"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "uU",
    "display": "microUnit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "uU/L",
    "display": "micro enzyme unit per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "uU/g",
    "display": "micro enzyme unit per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "uU/mL",
    "display": "micro enzyme unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "uV",
    "display": "microvolt"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "u[IU]",
    "display": "micro international unit"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "u[IU]/L",
    "display": "microinternational unit per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "u[IU]/mL",
    "display": "micro international unit per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ueq",
    "display": "microequivalents"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ueq/L",
    "display": "microequivalent per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ueq/mL",
    "display": "microequivalent per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug",
    "display": "microgram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/(100.g)",
    "display": "microgram per 100 gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/(24.h)",
    "display": "microgram per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/(8.h)",
    "display": "microgram per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/(kg.d)",
    "display": "microgram / kilogram * day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/(kg.h)",
    "display": "microgram / kilogram * hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/L",
    "display": "microgram per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/L/(24.h)",
    "display": "microgram per liter per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/[sft_i]",
    "display": "microgram per square foot (international)"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/d",
    "display": "microgram per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/dL",
    "display": "microgram per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/g",
    "display": "microgram per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/h",
    "display": "microgram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/kg",
    "display": "microgram per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/kg/(8.h)",
    "display": "microgram per kilogram per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/kg/d",
    "display": "microgram per kilogram per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/kg/h",
    "display": "microgram per kilogram per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/kg/min",
    "display": "microgram per kilogram per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/m2",
    "display": "microgram per square meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/m3",
    "display": "microgram per cubic meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/mL",
    "display": "microgram per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/mg",
    "display": "microgram per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/min",
    "display": "microgram per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/mmol",
    "display": "microgram per millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ug/ng",
    "display": "microgram per nanogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "ukat",
    "display": "microkatal"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "um",
    "display": "micrometer"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "um/s",
    "display": "micrometer per second"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol",
    "display": "micromole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/(2.h)",
    "display": "micromole per 2 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/(24.h)",
    "display": "micromole per 24 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/(8.h)",
    "display": "micromole per 8 hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/L",
    "display": "micromole per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/L/h",
    "display": "micromole per liter per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/d",
    "display": "micromole per day"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/dL",
    "display": "micromole per deciliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/g",
    "display": "micromole per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/h",
    "display": "micromole per hour"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/h/L",
    "display": "micromole per hour per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/h/g",
    "display": "micromole / hour / gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/h/mg",
    "display": "micromole per hour per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/kg",
    "display": "micromole per kilogram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/m",
    "display": "micromole / meter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/mL",
    "display": "micromole per milliliter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/mL/min",
    "display": "micromole per milliliter per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/mg",
    "display": "micromole per milligram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/min",
    "display": "micromole per minute"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/min/L",
    "display": "micromole per minute per liter"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/min/g",
    "display": "micromole per minute per gram"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/mmol",
    "display": "micromole per millimole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/mol",
    "display": "micromole per mole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "umol/umol",
    "display": "micromole per micromole"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "us",
    "display": "microsecond"
  },
  {
    "system": "http://unitsofmeasure.org",
    "code": "wk",
    "display": "week"
  }
]

const contributorRoleValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-role",
    "code": "publisher",
    "display": "Publisher",
    "definition": "Entity that makes the content available for public use"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-role",
    "code": "author",
    "display": "Author/Creator",
    "definition": "An entity primarily responsible for making the resource, often called author or creator"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-role",
    "code": "reviewer",
    "display": "Reviewer",
    "definition": "Entity that examines the content, formally or informally, and suggests revisions or comments"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-role",
    "code": "endorser",
    "display": "Endorser",
    "definition": "Entity that supports, approves, or advocates for the content"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-role",
    "code": "editor",
    "display": "Editor",
    "definition": "Entity that revises or has authority to control the content"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-role",
    "code": "informant",
    "display": "Informant",
    "definition": "Entity that supplies information"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-role",
    "code": "funder",
    "display": "Funder",
    "definition": "Entity that supplies financial support"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-role",
    "code": "recorder",
    "display": "Recorder",
    "definition": "Entity that entered the data into the Resource instance, if different than the author or creator of the intellectual property contained within the Resource instance"
  }
]

const contributorSummarySourceValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-source",
    "code": "publisher-data",
    "display": "Publisher provided",
    "definition": "Data copied by machine from publisher data."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-source",
    "code": "article-copy",
    "display": "Copied from article",
    "definition": "Data copied by human from article text."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-source",
    "code": "citation-manager",
    "display": "Reported by citation manager",
    "definition": "Data copied by machine from citation manager data."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-source",
    "code": "custom",
    "display": "custom format",
    "definition": "Custom format (may be described in text note)."
  }
]

const contributorSummaryStyleValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "a1full",
    "display": "First author (full name) et al",
    "definition": "Example: Jennifer Laskowski et al."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "a1init",
    "display": "First author (last name first initials) et al",
    "definition": "Example: Laskowski J et al."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "a3full",
    "display": "First 3 authors (full name) et al",
    "definition": "Example: Jennifer Laskowski, Brandon Renner, Matthew C. Pickering, et al."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "a3init",
    "display": "First 3 authors (last name first initials) et al",
    "definition": "Example:  Laskowski J, Renner B, Pickering MC, et al."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "a6full",
    "display": "First 6 authors (full name) et al",
    "definition": "Example: Jennifer Laskowski, Brandon Renner, Matthew C. Pickering, Natalie J. Serkova, Peter M. Smith-Jones, Eric T. Clambey, et al."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "a6init",
    "display": "First 6 authors (last name first initials) et al",
    "definition": "Example: Laskowski J, Renner B, Pickering MC, Serkova NJ, Smith-Jones PM, Clambey ET, et al."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "aallfull",
    "display": "All authors (full name)",
    "definition": "Example: Jennifer Laskowski, Brandon Renner, Matthew C. Pickering, Natalie J. Serkova, Peter M. Smith-Jones, Eric T. Clambey, Raphael A. Nemenoff, Joshua M. Thurman."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "aallfullwithand",
    "display": "All authors (full name) with and before last author",
    "definition": "Example: Jennifer Laskowski, Brandon Renner, Matthew C. Pickering, Natalie J. Serkova, Peter M. Smith-Jones, Eric T. Clambey, Raphael A. Nemenoff, and Joshua M. Thurman."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "aallfullwithampersand",
    "display": "All authors (full name) with an ampersand before last author",
    "definition": "Example: Jennifer Laskowski, Brandon Renner, Matthew C. Pickering, Natalie J. Serkova, Peter M. Smith-Jones, Eric T. Clambey, Raphael A. Nemenoff, & Joshua M. Thurman."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "aallinit",
    "display": "All authors (last name first initials)",
    "definition": "Example: Laskowski J, Renner B, Pickering MC, Serkova NJ, Smith-Jones PM, Clambey ET, Nemenoff RA, Thurman JM."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "aallinitwithand",
    "display": "All authors (last name first initials) with and before last author",
    "definition": "Example: Laskowski J, Renner B, Pickering MC, Serkova NJ, Smith-Jones PM, Clambey ET, Nemenoff RA, and Thurman JM."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "aallinitwithampersand",
    "display": "All authors (last name first initials) with an ampersand before last author",
    "definition": "Example: Laskowski J, Renner B, Pickering MC, Serkova NJ, Smith-Jones PM, Clambey ET, Nemenoff RA, & Thurman JM."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "contr-full-by-person",
    "display": "Contributorship statement listed by person with full names",
    "definition": "Jennnifer Laskowski designed project; developed and performed experiments; collected and analyzed data; wrote and revised manuscript. Brandon Renner performed critical review of manuscript. Matthew C. Pickering provided technical advice and contributed to study design. Natalie J. Serkova and Peter M. Smith-Jones performed PET imaging and associated analyses. Eric T. Clambey and Raphael A. Nemenoff provided conceptual and technical guidance and critical review of manuscript. Joshua M. Thurman contributed to experimental design and wrote manuscript."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "contr-init-by-person",
    "display": "Contributorship statement listed by person with initials",
    "definition": "J.L. designed project; developed and performed experiments; collected and analyzed data; wrote and revised manuscript. B.R. performed critical review of manuscript. M.C.P. provided technical advice and contributed to study design. N.J.S and P.M.S.-J. performed PET imaging and associated analyses. E.T.C. and R.A.N provided conceptual and technical guidance and critical review of manuscript. J.M.T contributed to experimental design and wrote manuscript."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "contr-full-by-contr",
    "display": "Contributorship statement listed by contribution with full names",
    "definition": "Project design by Jennnifer Laskowski (JL), Experiment design by JL and Joshua M. Thurman (JMT), technical advice and study design contribution by Matthew C. Pickering, experiments performed by JL, data collection and analysis by JL, PET imaging and associated analyses by Natalie J. Serkova and Peter M. Smith-Jones, conceptual and technical guidance by Eric T. Clambey (etc.) and Raphael A. Nemenoff (RAN), manuscript writing by JL and JMT, manuscript revised critically by JL, Brandon Renner, etc., and RAN."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-style",
    "code": "contr-init-by-contr",
    "display": "Contributorship statement listed by contribution with initials",
    "definition": "Project design by JL, Experiment design by JL and JMT, technical advice and study design contribution by MCP, experiments performed by JL, data collection and analysis by JL, PET imaging and associated analyses by NJS and PMS-J, conceptual and technical guidance by etc. and RAN, manuscript writing by JL and JMT, manuscript revised critically by JL, BR, etc., and RAN."
  }
]

const contributorSummaryTypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-type",
    "code": "author-string",
    "display": "Author string",
    "definition": "Display of the author list as a complete string."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-type",
    "code": "contributorship-list",
    "display": "Contributorship list",
    "definition": "Display of the list of contributors as a complete string."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-type",
    "code": "contributorship-statement",
    "display": "Contributorship statement",
    "definition": "Compiled summary of contributions."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-type",
    "code": "acknowledgement-list",
    "display": "Acknowledgment list",
    "definition": "Display of the list of acknowledged parties as a complete string."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-type",
    "code": "acknowledgment-statement",
    "display": "Acknowledgment statement",
    "definition": "Statement of acknowledgment of contributions beyond those compiled for formal contributorship statements."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-type",
    "code": "funding-statement",
    "display": "Funding statement",
    "definition": "Statement of financial support for the creation of the cited artifact."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/contributor-summary-type",
    "code": "competing-interests-statement",
    "display": "Competing interests statement",
    "definition": "Statement of completing interests related to the creation of the cited artifact. Also called conflicts of interest or declaration of interests."
  }
]

const evidenceCertatintyTypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/certainty-type",
    "code": "Overall",
    "display": "Overall certainty",
    "definition": "Overall certainty of evidence (quality of evidence)."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/certainty-type",
    "code": "RiskOfBias",
    "display": "Risk of bias",
    "definition": "methodologic concerns reducing internal validity."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/certainty-type",
    "code": "Inconsistency",
    "display": "Inconsistency",
    "definition": "concerns that findings are not similar enough to support certainty."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/certainty-type",
    "code": "Indirectness",
    "display": "Indirectness",
    "definition": "concerns reducing external validity."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/certainty-type",
    "code": "Imprecision",
    "display": "Imprecision",
    "definition": "fuzzy or wide variability."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/certainty-type",
    "code": "PublicationBias",
    "display": "Publication bias",
    "definition": "likelihood that what is published misrepresents what is available to publish."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/certainty-type",
    "code": "DoseResponseGradient",
    "display": "Dose response gradient",
    "definition": "higher certainty due to dose response relationship."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/certainty-type",
    "code": "PlausibleConfounding",
    "display": "Plausible confounding",
    "definition": "higher certainty due to risk of bias in opposite direction."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/certainty-type",
    "code": "LargeEffect",
    "display": "Large effect",
    "definition": "higher certainty due to large effect size."
  }
]

const evidenceDirectnessValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/directness",
    "code": "low",
    "display": "Low quality match between observed and intended variable",
    "definition": "Low matching quality between observed and intended variable, so very serious concern      for indirectness in evidence interpretation."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/directness",
    "code": "moderate",
    "display": "Moderate quality match between observed and intended variable",
    "definition": "Moderate matching quality between observed and intended variable, so serious concern      for indirectness in evidence interpretation."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/directness",
    "code": "high",
    "display": "High quality match between observed and intended variable",
    "definition": "High matching quality between observed and intended variable, so little concern      for indirectness in evidence interpretation."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/directness",
    "code": "exact",
    "display": "Exact match between observed and intended variable",
    "definition": "Exact matching quality between observed and intended variable, so no concern for      indirectness in evidence interpretation."
  }
]

const evidenceVariableRoleValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role",
    "code": "population",
    "display": "population",
    "definition": "variable represents a population."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role",
    "code": "subpopulation",
    "display": "subpopulation",
    "definition": "variable represents a subpopulation."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role",
    "code": "exposure",
    "display": "exposure",
    "definition": "variable represents an exposure."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role",
    "code": "referenceExposure",
    "display": "reference exposure",
    "definition": "variable represents a reference exposure."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role",
    "code": "measuredVariable",
    "display": "measured variable",
    "definition": "variable represents a measured variable."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role",
    "code": "confounder",
    "display": "confounder",
    "definition": "variable represents a confounder."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role",
    "code": "measuredVariableA",
    "display": "measured variable A",
    "definition": "variable represents a first of two measured variables to be used in a measured variable that is a mathematical operation of two measured variables."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role",
    "code": "measuredVariableB",
    "display": "measured variable B",
    "definition": "variable represents a second of two measured variables to be used in a measured variable that is a mathematical operation of two measured variables."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role",
    "code": "measuredVariableAB",
    "display": "measured variable A to B",
    "definition": "variable represents a result of a mathematical operation of two measured variables."
  }
]

const evidenceVariableRoleSubtypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role-subtype",
    "code": "population",
    "display": "population",
    "definition": "variable represents a population."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role-subtype",
    "code": "subpopulation",
    "display": "subpopulation",
    "definition": "variable represents a subpopulation."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role-subtype",
    "code": "exposure",
    "display": "exposure",
    "definition": "variable represents an exposure."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role-subtype",
    "code": "referenceExposure",
    "display": "reference exposure",
    "definition": "variable represents a reference exposure."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role-subtype",
    "code": "measuredVariable",
    "display": "measured variable",
    "definition": "variable represents a measured variable."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role-subtype",
    "code": "confounder",
    "display": "confounder",
    "definition": "variable represents a confounder."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role-subtype",
    "code": "measuredVariableA",
    "display": "measured variable A",
    "definition": "variable represents a first of two measured variables to be used in a measured variable that is a mathematical operation of two measured variables."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role-subtype",
    "code": "measuredVariableB",
    "display": "measured variable B",
    "definition": "variable represents a second of two measured variables to be used in a measured variable that is a mathematical operation of two measured variables."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/variable-role-subtype",
    "code": "measuredVariableAB",
    "display": "measured variable A to B",
    "definition": "variable represents a result of a mathematical operation of two measured variables."
  }
]

const listEmptyReasonValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/list-empty-reason",
    "code": "nilknown",
    "display": "Nil Known",
    "definition": "Clinical judgment that there are no known items for this list after reasonable investigation. Note that this a positive statement by a clinical user, and not a default position asserted by a computer system in the lack of other information. Example uses:  * For allergies: the patient or patient's agent/guardian has asserted that he/she is not aware of any allergies (NKA - nil known allergies)  * For medications: the patient or patient's agent/guardian has asserted that the patient is known to be taking no medications  * For diagnoses, problems and procedures: the patient or patient's agent/guardian has asserted that there is no known event to record."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/list-empty-reason",
    "code": "notasked",
    "display": "Not Asked",
    "definition": "The investigation to find out whether there are items for this list has not occurred."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/list-empty-reason",
    "code": "withheld",
    "display": "Information Withheld",
    "definition": "The content of the list was not provided due to privacy or confidentiality concerns. Note that it should not be assumed that this means that the particular information in question was withheld due to its contents - it can also be a policy decision."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/list-empty-reason",
    "code": "unavailable",
    "display": "Unavailable",
    "definition": "Information to populate this list cannot be obtained; e.g. unconscious patient."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/list-empty-reason",
    "code": "notstarted",
    "display": "Not Started",
    "definition": "The work to populate this list has not yet begun."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/list-empty-reason",
    "code": "closed",
    "display": "Closed",
    "definition": "This list has now closed or has ceased to be relevant or useful."
  }
]

const orderedByValueSet = [
  { "system": "http://terminology.hl7.org/CodeSystem/list-order", "code": "user", "display": "Sorted by User" },
  { "system": "http://terminology.hl7.org/CodeSystem/list-order", "code": "system", "display": "Sorted by System" },
  { "system": "http://terminology.hl7.org/CodeSystem/list-order", "code": "event-date", "display": "Sorted by Event Date" },
  { "system": "http://terminology.hl7.org/CodeSystem/list-order", "code": "entry-date", "display": "Sorted by Item Date" },
  { "system": "http://terminology.hl7.org/CodeSystem/list-order", "code": "priority", "display": "Sorted by Priority" },
  { "system": "http://terminology.hl7.org/CodeSystem/list-order", "code": "alphabetic", "display": "Sorted Alphabetically" },
  { "system": "http://terminology.hl7.org/CodeSystem/list-order", "code": "category", "display": "Sorted by Category" },
  { "system": "http://terminology.hl7.org/CodeSystem/list-order", "code": "patient", "display": "Sorted by Patient" },
  { "system": "http://terminology.hl7.org/CodeSystem/list-order", "code": "publication-date", "display": "Sorted by Publication Date" }
];

const publishedInTypeValueSet = [
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D020492",
    "display": "Periodical",
    "definition": "Publication intended to be issued on an ongoing basis, generally more frequently than annually, containing separate articles, stories, or writings."
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D019991",
    "display": "Database",
    "definition": "A structured file of information or a set of logically related data stored and retrieved using computer-based means."
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D001877",
    "display": "Book",
    "definition": "Non-periodical written or printed works consisting of sheets of pages fastened or bound together within covers."
  },
  {
    "system": "https://www.nlm.nih.gov/mesh",
    "code": "D064886",
    "display": "Dataset",
    "definition": "Works consisting of organized collections of data, which have been stored permanently in a formalized manner suitable for communication, interpretation, or processing."
  }
]

const titleTypeValueSet = [
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "primary",
    "display": "Primary title",
    "definition": "Main title for common use. The primary title used for representation if multiple titles exist."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "official",
    "display": "Official title",
    "definition": "The official or authoritative title."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "scientific",
    "display": "Scientific title",
    "definition": "Title using scientific terminology."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "plain-language",
    "display": "Plain language title",
    "definition": "Title using language common to lay public discourse."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "subtitle",
    "display": "Subtitle",
    "definition": "Subtitle or secondary title."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "short-title",
    "display": "Short title",
    "definition": "Brief title (e.g. 'running title' or title used in page headers)"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "acronym",
    "display": "Acronym",
    "definition": "Abbreviation used as title"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "earlier-title",
    "display": "Different text in an earlier version",
    "definition": "Alternative form of title in an earlier version such as epub ahead of print."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "language",
    "display": "Different language",
    "definition": "Additional form of title in a different language."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "autotranslated",
    "display": "Different language derived from autotranslation",
    "definition": "Machine translated form of title in a different language, language element codes the language into which it was translated by machine."
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "human-use",
    "display": "Human use",
    "definition": "Human-friendly title"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "machine-use",
    "display": "Machine use",
    "definition": "Machine-friendly title"
  },
  {
    "system": "http://terminology.hl7.org/CodeSystem/title-type",
    "code": "duplicate-uid",
    "display": "Different text for the same object with a different identifier",
    "definition": "An alternative form of the title in two or more entries, e.g. in multiple medline entries"
  }
];

const yesOrNoCodeableConceptSet = [
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C49488",
            "display": "Yes"
        }]
    },
    {
        "coding": [{
            "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
            "code": "C49487",
            "display": "No"
        }]
    }
];

const yesOrNoValueSet = [
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C49488",
        "display": "Yes"
    },
    {
        "system": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl",
        "code": "C49487",
        "display": "No"
    }
];

const valueSetDictionary = {
  artifactContributionInstanceTypeValueSet: artifactContributionInstanceTypeValueSet,
  artifactRelationshipTypeValueSet: artifactRelationshipTypeValueSet,
  artifactUrlClassifierValueSet: artifactUrlClassifierValueSet,
  citationArtifactClassifierValueSet: citationArtifactClassifierValueSet,
  citationClassificationTypeValueSet: citationClassificationTypeValueSet,
  citationSummaryStyleValueSet: citationSummaryStyleValueSet,
  citedArtifactAbstractTypeValueSet: citedArtifactAbstractTypeValueSet,
  citedArtifactClassificationTypeValueSet: citedArtifactClassificationTypeValueSet,
  citedArtifactContributionTypeValueSet: citedArtifactContributionTypeValueSet,
  citedArtifactPartTypeValueSet: citedArtifactPartTypeValueSet,
  citedArtifactStatusTypeValueSet: citedArtifactStatusTypeValueSet,
  citedMediumValueSet: citedMediumValueSet,
  commonUCUMUnitsValueSet: commonUCUMUnitsValueSet,
  contributorRoleValueSet: contributorRoleValueSet,
  contributorSummarySourceValueSet: contributorSummarySourceValueSet,
  contributorSummaryStyleValueSet: contributorSummaryStyleValueSet,
  contributorSummaryTypeValueSet: contributorSummaryTypeValueSet,
  evidenceCertatintyTypeValueSet: evidenceCertatintyTypeValueSet,
  evidenceDirectnessValueSet: evidenceDirectnessValueSet,
  evidenceVariableRoleValueSet: evidenceVariableRoleValueSet,
  evidenceVariableRoleSubtypeValueSet: evidenceVariableRoleSubtypeValueSet,
  listEmptyReasonValueSet: listEmptyReasonValueSet,
  orderedByValueSet: orderedByValueSet,
  publishedInTypeValueSet: publishedInTypeValueSet,
  titleTypeValueSet: titleTypeValueSet
}

const convertValueSetToCodeableConceptSet = (valueSet) => {
  let codeableConceptSet = [];
  let selectedValueSet = [];
  if (typeof valueSet === "string") {
    selectedValueSet = valueSetDictionary[valueSet];
  }
  if (Array.isArray(valueSet)) {
    selectedValueSet = valueSet;
  }
  if (Array.isArray(selectedValueSet) && selectedValueSet.length) {
    codeableConceptSet = selectedValueSet.map(coding => {
      return {
        "coding": [{
          "system": coding.system,
          "code": coding.code,
          "display": coding.display
        }]
      };
    });
  }
  return codeableConceptSet;
}

const generateValueSetLookup = (valueSet) => {
  let valueSetLookup = {};
  let selectedValueSet = [];
  if (typeof valueSet === "string") {
    selectedValueSet = valueSetDictionary[valueSet];
  }
  if (Array.isArray(valueSet)) {
    selectedValueSet = valueSet;
  }
  if (Array.isArray(selectedValueSet) && selectedValueSet.length) {
    for (const concept of selectedValueSet) {
      valueSetLookup[concept.code] = {
        "display": concept.display,
        "definition": concept.definition,
        "system": concept.system
      }
    }
  }
  return valueSetLookup;
}

const generateValueSetOptions = (valueSet) => {
  let valueSetOptions = [];
  let selectedValueSet = [];
  if (typeof valueSet === "string") {
    selectedValueSet = valueSetDictionary[valueSet];
  }
  if (Array.isArray(valueSet)) {
    selectedValueSet = valueSet;
  }
  if (Array.isArray(selectedValueSet) && selectedValueSet.length) {
    valueSetOptions = selectedValueSet.map(concept => {
      return {
        key: concept.code,
        text: concept.display,
        value: concept.code,
        definition: concept.definition,
        system: concept.system
      }
    });
  }
  return valueSetOptions;
}

export { 
  fevirPublicationStatusValueSet, fevirPublicationStatusRetracted, fevirPublicationStatusDraft,
  fevirPublicationStatusActive, artifactRelationshipTypeValueSet, artifactRelationshipTypeValueSetLookup,
  artifactContributionInstanceTypeValueSet, artifactUrlClassifierValueSet,
  citationArtifactClassifierValueSet, citationClassificationTypeValueSet,
  citationSummaryStyleValueSet, citedArtifactAbstractTypeValueSet, citedArtifactClassificationTypeValueSet,
  citedArtifactContributionTypeValueSet, citedArtifactPartTypeValueSet, citedArtifactStatusTypeValueSet,
  citedMediumValueSet, commonUCUMUnitsValueSet, contributorRoleValueSet,
  contributorSummarySourceValueSet, contributorSummaryStyleValueSet, contributorSummaryTypeValueSet,
  evidenceCertatintyTypeValueSet, evidenceDirectnessValueSet, evidenceVariableRoleValueSet,
  evidenceVariableRoleSubtypeValueSet, listEmptyReasonValueSet,
  orderedByValueSet, publishedInTypeValueSet, titleTypeValueSet,
  yesOrNoCodeableConceptSet, yesOrNoValueSet,
  convertValueSetToCodeableConceptSet, generateValueSetLookup, generateValueSetOptions
};